function cov_d4s8m45os() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/New.tsx";
  var hash = "6f440a229414ef1135101526b80598b93a3a9dab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/New.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6f440a229414ef1135101526b80598b93a3a9dab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_d4s8m45os = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_d4s8m45os();
var Icon = (cov_d4s8m45os().s[0]++, {
  name: 'new',
  svg: "<rect y=\"5\" width=\"24\" height=\"14\" rx=\"7\" fill=\"currentColor\"/>\n  <path d=\"M4.99213 14H6.00013V10.437L8.08613 14H9.22013V8.995H8.21213V12.292L6.30813 8.995H4.99213V14ZM11.8586 14.077C12.8596 14.077 13.4896 13.636 13.6086 12.845H12.6496C12.5866 13.153 12.3556 13.356 11.8866 13.356C11.3336 13.356 11.0046 13.006 10.9766 12.397H13.6156V12.117C13.6156 10.808 12.7756 10.255 11.8306 10.255C10.7666 10.255 9.94763 11.004 9.94763 12.159V12.215C9.94763 13.384 10.7526 14.077 11.8586 14.077ZM10.9906 11.774C11.0676 11.256 11.3756 10.955 11.8306 10.955C12.3136 10.955 12.5936 11.221 12.6286 11.774H10.9906ZM14.9887 14H15.9967L16.6687 11.704L17.2917 14H18.2857L19.4407 10.339H18.4677L17.7747 12.803L17.1307 10.339H16.2977L15.5907 12.803L14.9397 10.339H13.8757L14.9887 14Z\" fill=\"white\"/>"
});
export default Icon;